<template>
    <div class="container" :class="{'fullscreen': fullscreen}">
        <template v-if="loaded">
        <div class="row justify-content-center">
            <div class="col-12 px-1 mb-2">
                <div class="card">
                    <div class="card-header">
                        <button v-if="!fullscreen" type="button" class="btn btn-secondary btn-sm back-button align-middle" @click="goBack"><i class="fas fa-chevron-left"></i></button>
                        <h4 class="mb-0 d-inline-block align-middle" :class="{'ml-2': !fullscreen, 'ml-0': fullscreen}">{{ board.group.title }} - {{ board.title }}</h4>
                        <div class="d-inline-block float-right">
                            <button v-if="moreTimes" @click="showMore" class="btn btn-sm btn-secondary mx-1"><i class="fas fa-plus"></i> Display More</button>
                            <button @click="fullscreenToggle" class="btn btn-sm btn-secondary mx-1 d-none d-lg-inline-block"><i class="fas" :class="{'fa-expand': !fullscreen, 'fa-compress': fullscreen}"></i> <template v-if="fullscreen">Exit</template><template v-else>Enter</template> Fullscreen</button>
                        </div>
                    </div>
                </div>
            </div>
            <template v-for="(time, i) in topTimes">
                <template v-if="time.board.type === 'time'">
                    <time-card @edit="edit" @editfinished="editFinished" @delete="scoreDelete" :fullscreen="fullscreen" :time="time" :key="time.id" :position="i+1"></time-card>
                </template>
                <template v-else>
                    <score-card @edit="edit" @editfinished="editFinished" @delete="scoreDelete" :fullscreen="fullscreen" :time="time" :key="time.id" :position="i+1"></score-card>
                </template>
            </template>

            <template v-if="authUser && !fullscreen">
                <template v-if="board.type === 'time'">
                    <div class="col-12 px-1 mb-2">
                        <div class="card">
                            <div class="card-header">Add Time</div>
                            <div class="card-body">
                                <form @submit.prevent="submitTime" class="form-inline">
                                    <div class="form-group mr-2">
                                        <label for="name" class="sr-only">Name</label>
                                        <input type="text" name="name" id="name" v-model="newTime.name" placeholder="Name" class="form-control">
                                    </div>
                                    <div class="form-group mr-2">
                                        <label for="time" class="sr-only">Time</label>
                                        <input type="text" name="time" id="time" v-model="newTime.time" placeholder="Time MM:SS.ms" class="form-control">
                                    </div>
                                    <div class="form-group mr-2">
                                        <label for="gunType" class="sr-only">Gun Type</label>
                                        <select name="gunType" id="gunType" v-model="newTime.weapon_type_id" class="form-control" placeholder="Gun Type">
                                            <option v-for="typeOption in weaponTypes" :value="typeOption.id" :key="typeOption.id">{{ typeOption.title }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group mr-2">
                                        <label for="gunModel" class="sr-only">Gun Model</label>
                                        <input type="text" name="gunModel" id="gunModel" v-model="newTime.weapon" placeholder="Gun Model" class="form-control">
                                    </div>
                                    <div class="form-group mr-2">
                                        <label for="bbWeight" class="sr-only">BB Weight</label>
                                        <input type="text" name="bbWeight" id="bbWeight" v-model="newTime.bb_weight" placeholder="BB Weight" class="form-control">
                                    </div>
                                    <button type="submit" class="btn btn-primary">Add Time</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="col-12 px-1 mb-2">
                        <div class="card">
                            <div class="card-header">Add Score</div>
                            <div class="card-body">
                                <form @submit.prevent="submitTime" class="form-inline">
                                    <div class="form-group mr-2 mt-2">
                                        <label for="name" class="sr-only">Name</label>
                                        <input type="text" name="name" id="name" v-model="newTime.name" placeholder="Name" class="form-control">
                                    </div>
                                    <div class="form-group mr-2 mt-2">
                                        <label for="points" class="sr-only">Score</label>
                                        <input type="text" name="points" id="points" v-model="newTime.points" placeholder="Score 0000" class="form-control">
                                    </div>
                                    <div class="form-group mr-2 mt-2">
                                        <label for="time" class="sr-only">Time</label>
                                        <input type="text" name="time" id="time" v-model="newTime.time" placeholder="Time 00:00.00" class="form-control">
                                    </div>
                                    <div class="form-group mr-2 mt-2">
                                        <label for="gunType" class="sr-only">Gun Type</label>
                                        <select name="gunType" id="gunType" v-model="newTime.weapon_type_id" class="form-control" placeholder="Gun Type">
                                            <option v-for="typeOption in weaponTypes" :value="typeOption.id" :key="typeOption.id">{{ typeOption.title }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group mr-2 mt-2">
                                        <label for="gunModel" class="sr-only">Gun Model</label>
                                        <input type="text" name="gunModel" id="gunModel" v-model="newTime.weapon" placeholder="Gun Model" class="form-control">
                                    </div>
                                    <div class="form-group mr-2 mt-2">
                                        <label for="bbWeight" class="sr-only">BB Weight</label>
                                        <input type="text" name="bbWeight" id="bbWeight" v-model="newTime.bb_weight" placeholder="BB Weight" class="form-control">
                                    </div>
                                    <button type="submit" class="btn btn-primary">Add Time</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="col-12 px-1 mb-2">
                    <div class="card">
                        <div class="card-header">Email Board Link</div>
                        <div class="card-body">
                            <form @submit.prevent="sendLink" class="form-inline">
                                <div class="form-group mr-2">
                                    <label for="email" class="sr-only">Email Address</label>
                                    <input type="email" name="email" id="email" v-model="emailLink.email" placeholder="email@email.com" class="form-control">
                                </div>
                                <button v-if=" ! emailSend.status && emailLink.email" type="submit" class="btn btn-primary">Send Link</button>
                                <button v-else-if="emailSend.status == 'success'" type="submit" class="btn btn-success disabled" disabled>Email Sent</button>
                                <button v-else-if="emailSend.status == 'failed'" type="submit" class="btn btn-danger disabled" disabled>Email Failed</button>
                                <button v-else-if="emailSend.status == 'pending'" type="submit" class="btn btn-primary disabled" disabled>Sending <i class="fas fa-spinner fa-pulse"></i></button>
                                <button v-else type="submit" class="btn btn-primary disabled" disabled>Send Link</button>
                            </form>
                        </div>
                    </div>
                </div>
            </template>

            <permalink v-if="!fullscreen" type="board" :id="id"></permalink>
        </div>
        </template>
        <template v-else>
            <div class="col px-1">
                <div class="card">
                    <div class="card-header">Loading Data</div>

                    <div class="card-body">
                        <div class="progress">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            default: false
        },
    },
    data() {
        return {
            board: {},
            times: [],
            weaponTypes: [],
            updateInterval: false,
            boardSize: 10,
            boardTable: false,
            loaded: false,
            fullscreen: false,
            authUser: window.authUser || false,
            valid: true,
            validationCheck: {
                name: false,
                time: false,
                weapon_type_id: false,
                weapon: false,
                bb_weight: false,
            },
            newTime: {
                name: "",
                board_id: this.id,
                time: "",
                weapon_type_id: false,
                recorded_date: "",
                weapon: "",
                bb_weight: "",
                points: null,
            },
            emailLink: {
                email: "",
            },
            emailSend: {
                status: null,
            },
            base: {
                name: "",
                board_id: this.id,
                time: "",
                weapon_type_id: false,
                recorded_date: "",
                weapon: "",
                bb_weight: "",
                points: null,
            },
            adding: false,
            addSuccess: false,
            addFailed: false,
            editing: false,
        }
    },
    computed: {
        topTimes() {
            let timesList = Object.assign([], this.times);
            timesList.sort((a,b) => {
                if (a.points > b.points) {
                    return -1;
                }

                if (a.points < b.points) {
                    return 1;
                }

                if (a.time < b.time) {
                    return -1;
                }
                if (a.time > b.time) {
                    return 1;
                }

                if (a.recorded_date < b.recorded_date) {
                    return -1;
                }
                if (a.recorded_date > b.recorded_date) {
                    return 1;
                }

                return 0;
            });

            let top = timesList.slice(0, this.boardSize);

            return top;
        },
        moreTimes() {
            return this.times.length > this.boardSize;
        },
    },
    methods: {
        goBack() {
            this.$emit("back");
        },
        showMore() {
            this.boardSize = this.boardSize + 10;
        },
        edit() {
            this.editing = true;
        },
        editFinished() {
            this.editing = false;
            this.loadBoard();
        },
        loadBoard(firstRun) {
            if (this.editing) {
                return;
            }

            axios.get(`/board/${this.id}`)
                .then((result) => {
                    this.board = result.data;

                    document.title = `The Extreme Airsoft - Scoreboard - Board: ${this.board.title}`;

                    if(firstRun) {
                        this.times = Object.assign([], []);
                    }

                    this.board.scores.forEach((score) => {
                        let i = this.times.findIndex((time) => {
                            return time.id === score.id;
                        })

                        if (i != -1) {
                            this.$set(this.times, i, score);
                        } else {
                            this.$set(this.times, this.times.length, score);
                        }
                    })

                    this.loaded = true;
                })
                .catch((err) => {
                    console.error(err);
                })
        },
        fullscreenToggle() {
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                    document.msExitFullscreen();
                }
                this.$emit('fullscreenstop');
            } else {
                var elem = document.getElementsByTagName('html')[0];
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                    elem.msRequestFullscreen();
                }
                this.$emit('fullscreengo');
            }

            this.fullscreen = !this.fullscreen;
        },
        validation() {
            this.valid = true;

            this.validationCheck.name = this.newTime.name.length;
            this.validationCheck.time = this.newTime.time.length;
            this.validationCheck.weapon_type_id = this.newTime.weapon_type_id.length;
            this.validationCheck.weapon = this.newTime.weapon.length;
            this.validationCheck.bb_weight = this.newTime.bb_weight.length;

            if (
                this.validationCheck.name &&
                this.validationCheck.time &&
                this.validationCheck.weapon_type_id &&
                this.validationCheck.weapon &&
                this.validationCheck.bb_weight
            ) {
                this.valid = true;
            } else {
                this.valid = false;
            }

            return this.valid;
        },
        scoreDelete(score) {
            this.$bvToast.toast(`Score deleted for ${score.name}`, {
                title: 'Delete Score',
                autoHideDelay: 3000,
                appendToast: true,
                toaster: 'b-toaster-top-right',
            });

            this.loadBoard(true);
        },
        submitTime() {
            this.newTime.recorded_date = new moment().format('YYYY-MM-DD HH:mm:SS');
            if (this.validation()) {
                axios.post('/score/add', this.newTime)
                    .then((result) => {
                        let name = this.newTime.name;
                        this.$bvToast.toast(`Score added for ${name}`, {
                            title: 'New Time',
                            autoHideDelay: 3000,
                            appendToast: true,
                            toaster: 'b-toaster-top-right',
                        });

                        this.newTime = Object.assign({}, this.base);
                        this.loadBoard();
                    })
                    .catch((err) => {
                        console.error(err);
                    })
            }
        },
        sendLink() {
            this.emailSend.status = 'pending';
            axios.post(`/board/send/${this.id}`, this.emailLink)
                .then((result) => {
                    this.$bvToast.toast(`Email sent to ${this.emailLink.email}`, {
                        title: 'Email Send',
                        autoHideDelay: 3000,
                        appendToast: true,
                        toaster: 'b-toaster-top-right',
                    });

                    this.emailSend.status = 'success';
                    this.emailLink.email = null;

                    setTimeout(() => {
                        this.emailSend.status = null;
                    }, 2000);
                })
                .catch((err) => {
                    console.error(err);
                    this.emailSend.status = 'failed';

                    setTimeout(() => {
                        this.emailSend.status = null;
                    }, 2000);
                })
        },
        exitHandler() {
            if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                this.fullscreen = false;
            }
        },
    },
    mounted() {
        this.loadBoard(true);
        this.updateInterval = setInterval(this.loadBoard.bind(this), 10 * 1000);
        if (this.authUser) {
            axios.get('/weapontype')
                .then((result) => {
                    this.weaponTypes = result.data;
                })
                .catch((err) => {
                    console.error(err);
                })
        }
        this.newTime = Object.assign({}, this.base);

        document.addEventListener('fullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('webkitfullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('mozfullscreenchange', this.exitHandler.bind(this));
        document.addEventListener('MSFullscreenChange', this.exitHandler.bind(this));
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
        this.loaded = false;

        document.removeEventListener('fullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('webkitfullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('mozfullscreenchange', this.exitHandler.bind(this));
        document.removeEventListener('MSFullscreenChange', this.exitHandler.bind(this));
    },
}
</script>